import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';
import { accountLedgerActions } from '../actions/account-ledger.actions';
import { AccountLedgerService } from '../services/account-ledger.service';

function messageOf(error: unknown): string {
    return error instanceof HttpErrorResponse ? `HTTP ${error.status}` : 'unknown error';
}

@Injectable()
export class AccountLedgerEffects {
    public constructor(private readonly actions$: Actions, private readonly service: AccountLedgerService) {}

    // A new account cancels the request for the previous one.
    public readonly load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(accountLedgerActions.load),
            switchMap(({ projectId, accountId }) =>
                this.service.page(projectId, accountId, null).pipe(
                    map((page) => accountLedgerActions.loadSuccess({ projectId, accountId, page })),
                    catchError((error: unknown) =>
                        of(accountLedgerActions.loadFailure({ projectId, accountId, error: messageOf(error) })),
                    ),
                ),
            ),
        ),
    );

    // A second click while a page is on its way asks for nothing: it would fetch the same page twice.
    public readonly loadMore$ = createEffect(() =>
        this.actions$.pipe(
            ofType(accountLedgerActions.loadMore),
            exhaustMap(({ projectId, accountId, cursor }) =>
                this.service.page(projectId, accountId, cursor).pipe(
                    map((page) => accountLedgerActions.loadMoreSuccess({ projectId, accountId, page })),
                    catchError((error: unknown) =>
                        of(accountLedgerActions.loadMoreFailure({ projectId, accountId, error: messageOf(error) })),
                    ),
                ),
            ),
        ),
    );
}
